import { useTranslation } from "react-i18next";

const GenerateVideoProgressBar = ({ progress = 0, className = "" }) => {
  const { t } = useTranslation();

  return (
    <div className={`w-full ${className}`}>
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-semibold text-gray-700">
          {t("generating video")}
        </span>
        <span className="text-sm font-semibold text-gray-700">
          {progress.toFixed(1)}%
        </span>
      </div>
      <div className="w-full h-4 bg-gray-200 rounded-full overflow-hidden shadow-inner">
        <div
          className="h-full bg-gradient-to-r from-empowerStart-500 via-empowerVia-500 to-empowerTo-500 rounded-full transition-all duration-300 ease-out"
          style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
        />
      </div>
    </div>
  );
};

export default GenerateVideoProgressBar;
